<template>
  <div class="gateway-list-container">
    <!-- 操作栏 -->
    <div class="table-toolbar">
      <el-button 
        type="danger" 
        size="mini" 
        icon="el-icon-delete"
        :disabled="selectedRows.length === 0"
        @click="handleBatchDelete">
        批量移除 ({{ selectedRows.length }})
      </el-button>
    </div>
    
    <!-- 表格区域 -->
    <el-table
      :data="tableData"
      v-loading="loading"
      @selection-change="handleSelectionChange"
      max-height="500"
      border
      style="width: 100%">
      <el-table-column type="selection" width="55" align="center"></el-table-column>
      <el-table-column prop="name" label="网关名称" min-width="150" align="center"></el-table-column>
      <el-table-column prop="productType" label="网关类型" min-width="120" align="center"></el-table-column>
      <el-table-column prop="macAddr" label="网关地址" min-width="150" align="center"></el-table-column>
      <el-table-column prop="blackCount" label="黑名单屏蔽数" min-width="150" align="center"></el-table-column>
      <el-table-column prop="groupName" label="归属分组" min-width="120" align="center"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" min-width="150" align="center"></el-table-column>
      <el-table-column label="操作" width="100" align="center" fixed="right" :header-cell-style="{ background: '#fafafa' }">
        <template slot-scope="scope">
          <el-button 
            type="text" 
            size="small" 
            @click="handleRemove(scope.row)"
            style="color: #f56c6c;">
            移除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 分页组件 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pagination.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GatewayList',
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object,
      default: () => ({
        page: 1,
        size: 10,
        total: 0
      })
    }
  },
  data() {
    return {
      selectedRows: []
    };
  },
  methods: {
    handleSelectionChange(selection) {
      this.selectedRows = selection;
      this.$emit('selection-change', selection);
    },
    
    handleRemove(row) {
      this.$emit('remove', row);
    },
    
    handleBatchDelete() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择要移除的数据');
        return;
      }
      
      this.$emit('batch-delete', this.selectedRows);
    },
    
    handleSizeChange(size) {
      this.$emit('size-change', size);
    },
    
    handleCurrentChange(page) {
      this.$emit('current-change', page);
    }
  }
};
</script>

<style scoped>
.gateway-list-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.table-toolbar {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 0;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  padding: 10px 0;
}

/* 操作列固定表头的背景色 */
.gateway-list-container >>> .el-table__fixed-right .el-table__fixed-header-wrapper thead th:last-child {
  background-color: #fafafa !important;
}

/* 普通表头的背景色 */
.gateway-list-container >>> .el-table__header-wrapper .el-table__header th {
  background-color: #fafafa;
}
</style>